<div class="edit-map-modal">
  <div class="edit-map-header">
    <h5>Update Map</h5>
    <button type="button" class="edit-map-close" aria-label="Close" (click)="closemodel()">
      <img src="assets/icons/icon-close.svg" alt="" />
    </button>
  </div>

  <form [formGroup]="editmapdata" enctype="multipart/form-data">
    <div class="form-group">
      <label class="form-label">Map Name</label>
      <input type="text" formControlName="map_name" class="form-control" />
      @if (editmapdata.controls['map_name'].hasError('required') &&
        (editmapdata.controls['map_name'].dirty ||
        editmapdata.controls['map_name'].touched || submitted)) {
        <span class="error-message">Map Name is required.</span>
      }
    </div>

    <div class="form-group">
      <label class="form-label">Upload Image</label>
      <input type="file" formControlName="mapfile" accept=".map" (change)="handleFileInput($event)" class="form-control" />
    </div>

    <label class="edit-map-checkbox">
      <input type="checkbox">
      Append
    </label>

    <button type="submit" (click)="onSubmit()" [disabled]="isLoading" class="btn btn-theme edit-map-submit">
      @if (isLoading) {
        <span class="edit-map-spinner" aria-hidden="true"></span>
      }
      Submit
    </button>
  </form>
</div>
